import React from "react";
import "../styles/WhyWeAreBest.css";
import { FaStar, FaNetworkWired, FaUsers, FaHandshake } from "react-icons/fa";

function WhyWeAreBest() {
  const cards = [
    {
      icon: <FaStar />,
      title: "Top Quality",
      // text: "We ensure premium standards in every service we deliver."
    },
    {
      icon: <FaNetworkWired />,
      title: "Supply Chain",
      // text: "Cutting-edge strategies tailored to your unique needs."
    },
    {
      icon: <FaUsers />,
      title: "Expert Team",
      // text: "Professionals with years of proven industry experience."
    },
    {
      icon: <FaHandshake />,
      title: "Trusted Partnerships",
      // text: "Helping you achieve measurable and sustainable success."
    }
  ];

  return (
    <section className="why-best">
      <div className="overlay">
        <h2>Why We Are Best</h2>
        <div className="cards">
          {cards.map((card, index) => (
            <div key={index} className="card">
              <div className="icon">{card.icon}</div>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyWeAreBest;
